import { last } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import { exhibitorsFilter, isExhibitorsFilterActive } from '../../../data/filters/exhibitorsFilters';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useExhibitors, useExhibitorsFilter } from '../../../data/hooks/exhibitor/exhibitorHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import UncontrolledExhibitorsInteractiveMap from '../../screens/EventMap/common/UncontrolledExhibitorsInteractiveMap';
import EventExhibitorsMapButton from '../common/Toolbar/EventExhibitorsMapButton';
import EventMapButton from '../common/Toolbar/EventMapButton';
import SidePanelToolbar from '../common/Toolbar/SidePanelToolbar';
import SidePanelWrapper from '../SidePanelWrapper';
import { useDirectoryItem } from '../../../data/hooks/directory/directoryHooks';
import { useSidePanelCenterMap } from '../../../data/hooks/ui/useCenterMap';

const FloorPlan = (props) => {
    const { eventId, path = '' } = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        filter = useExhibitorsFilter(eventId),
        exhibitors = useExhibitors(eventId, {
            filter: (i) => !!i.coordinates,
        }),
        filteredExhibitors = useMemo(() => exhibitors.filter((e) => exhibitorsFilter(filter, e)), [exhibitors, filter]),
        { map_url, exhibitors_map_url } = event,
        centerMap = useSidePanelCenterMap(),
        exhibitorId = useMemo(() => last(path.split('/')), [path]),
        exhibitor = useMemo(() => exhibitors.find((e) => e.id == exhibitorId), [exhibitorId, exhibitors]),
        dispatch = useDispatch(),
        { pathname } = useLocation();

    const handlePinClicked = (id) => {
        if (exhibitorId != id) {
            app.history.push(['/events', eventId, 'exhibitors', id.toString()].join('/'));
        }
    };

    if (!exhibitors_map_url) return null;

    return (
        <SidePanelWrapper>
            <SidePanelToolbar>
                {map_url && exhibitors_map_url ? (
                    <>
                        <EventMapButton event={event} />
                        <EventExhibitorsMapButton event={event} isActive />
                    </>
                ) : (
                    <div className="title">{event.settings.exhibitors_map_label || i18n['label.exhibitors']}</div>
                )}
            </SidePanelToolbar>
            <UncontrolledExhibitorsInteractiveMap
                eventId={eventId}
                src={exhibitors_map_url}
                exhibitors={exhibitors}
                highlightExhibitors={isExhibitorsFilterActive(filter) ? filteredExhibitors || [] : exhibitor ? [exhibitor] : []}
                selected={exhibitorId}
                onPinClicked={handlePinClicked}
                centerPosition={centerMap}
            />
        </SidePanelWrapper>
    );
};

export default (props) => {
    const params = props?.match?.params || useParams();
    return <FloorPlan {...params} />;
};
